import { render } from "./ItinerarioViajes.vue?vue&type=template&id=4050b861"
import script from "./ItinerarioViajes.vue?vue&type=script&lang=js"
export * from "./ItinerarioViajes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__